import { Tooltip, TooltipProvider, TooltipTrigger } from '@components/ui/tooltip';
import { getRelativeDateTimeText, getAbsoluteDateTimeText } from '@asset/function/timeFunctions';
import { TooltipArrow } from '@radix-ui/react-tooltip';
import * as S from '@styles/common/dateTimeRelativeText.style';
import { KST } from 'constants/time';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DateTimeRelativeText = ({
  dateTime,
  timezone = KST
}) => {
  const relativeText = getRelativeDateTimeText(dateTime);
  const tooltipText = getAbsoluteDateTimeText(dateTime, timezone);
  return /*#__PURE__*/_jsx(TooltipProvider, {
    children: /*#__PURE__*/_jsxs(Tooltip, {
      children: [/*#__PURE__*/_jsx(TooltipTrigger, {
        asChild: true,
        children: /*#__PURE__*/_jsx("span", {
          children: relativeText
        })
      }), /*#__PURE__*/_jsxs(S.DateTimeRelativeTextTooltipContent, {
        side: "top",
        sideOffset: 6,
        children: [tooltipText, /*#__PURE__*/_jsx(TooltipArrow, {
          style: {
            fill: 'var(--gray-20)'
          }
        })]
      })]
    })
  });
};
export default DateTimeRelativeText;